import { forwardRef } from "react";
import React from "react";
import { FaCode, FaMobileAlt, FaServer, FaGraduationCap } from "react-icons/fa";

const About = forwardRef(function About(props, refAbout) {
  const skills = [
    {
      title: "Android Development",
      description: "Building native, performant Android applications with Kotlin and Java, focusing on clean architecture and smooth user experiences.",
      icon: <FaMobileAlt className="text-4xl text-[#00df9a] mb-4 group-hover:scale-110 transition-transform duration-300" />
    },
    {
      title: "Frontend Web",
      description: "Crafting responsive, modern web interfaces using React, Tailwind CSS, and other modern web technologies.",
      icon: <FaCode className="text-4xl text-emerald-400 mb-4 group-hover:scale-110 transition-transform duration-300" />
    },
    {
      title: "Backend Integration",
      description: "Connecting apps to robust backends using Firebase and RESTful APIs to ensure seamless data flow and authentication.",
      icon: <FaServer className="text-4xl text-[#00df9a] mb-4 group-hover:scale-110 transition-transform duration-300" />
    },
    {
      title: "Continuous Learning",
      description: "Always expanding my skill set through bootcamps, masterclasses, and hands-on projects to stay ahead in tech.",
      icon: <FaGraduationCap className="text-4xl text-emerald-400 mb-4 group-hover:scale-110 transition-transform duration-300" />
    }
  ];

  return (
    <div className="page flex flex-col items-center justify-center min-h-screen px-6 md:px-20 py-20" ref={refAbout}>
      <div className="w-full max-w-6xl">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400 drop-shadow-lg mb-6">
            Who I Am
          </h1>
          <p className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            I am a passionate Software Developer specializing in <span className="text-white font-bold">Android</span> and <span className="text-white font-bold">Web Development</span>. 
            I love transforming complex problems into elegant, user-friendly solutions. 
            With a strong foundation in modern frameworks and a keen eye for design, I build applications that not only work flawlessly but also look great.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {skills.map((skill, index) => (
            <div 
              key={index} 
              className="group bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-[#00df9a]/50 shadow-xl hover:shadow-[#00df9a]/20 hover:-translate-y-2 transition-all duration-300"
            >
              <div className="flex flex-col items-start">
                {skill.icon}
                <h3 className="text-2xl font-bold text-white mb-3">{skill.title}</h3>
                <p className="text-gray-400 leading-relaxed">
                  {skill.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default About;
